export default "__VITE_ASSET__0d73180d__"